import * as Animate from "react-reveal";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import { ArrowUpRight } from "../../../components/svgs";
import TeamImg from "../../../assets/images/png/executive-leaders.webp";

const BusinessHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      id="top"
      style={{
        backgroundImage: "linear-gradient(#fff 0%, #f7f9ff 100%)",
      }}
    >
      <HeaderNavigation />
      <GroupSubNav />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center ">
          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Utiva for Business
              </p>

              <h1 className="text-4xl md:text-5xl lg:text-business-hero font-poppins tracking-[-0.03em] leading-[1.1] font-black mb-7 text-primary">
                Train your talent.{" "}
                <mark
                  className="bg-secondary text-primary px-1"
                  style={{
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                  }}
                >
                  Hire great people.
                </mark>{" "}
                Pay globally.
              </h1>

              <p className="font-poppins text-lg md:text-lg text-gray leading-relaxed mb-9 max-w-xl">
                One connected Utiva partnership helps you develop practical AI,
                technology and business capability, find job-ready talent and
                support teams across borders.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg mb-10">
                <a
                  href="#request"
                  className="text-white bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center font-bold shadow-course-feature focus:outline-none"
                >
                  Build a workforce plan
                  <span className="ml-2">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </a>
                <a
                  href="#journey"
                  className="text-primary text-base font-poppins font-bold underline decoration-secondary decoration-2 underline-offset-4 hover:opacity-80 transition-all"
                >
                  Explore business solutions ↓
                </a>
              </div>

              <div className="grid grid-cols-3 gap-6 pt-6 border-t border-hire-line font-poppins">
                <div>
                  <strong className="block text-primary text-sm font-extrabold tracking-wide uppercase mb-1.5">
                    Train
                  </strong>
                  <span className="text-gray text-sm leading-snug block">
                    build the capability your strategy needs
                  </span>
                </div>
                <div>
                  <strong className="block text-primary text-sm font-extrabold tracking-wide uppercase mb-1.5">
                    Hire
                  </strong>
                  <span className="text-gray text-sm leading-snug block">
                    access focused, job-ready talent
                  </span>
                </div>
                <div>
                  <strong className="block text-primary text-sm font-extrabold tracking-wide uppercase mb-1.5">
                    Pay
                  </strong>
                  <span className="text-gray text-sm leading-snug block">
                    support teams working across borders
                  </span>
                </div>
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "580px" }}
              >
                <img
                  src={TeamImg}
                  alt="Business leaders planning a workforce strategy with Utiva"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "55%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.92))",
                  }}
                ></div>

                <div className="absolute z-10 bottom-7 left-7 right-7 font-poppins">
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-2">
                    One business partnership
                  </p>
                  <h2 className="text-white text-2xl md:text-3xl font-poppins font-extrabold leading-tight mb-5">
                    Build stronger people, better teams and a borderless
                    workforce.
                  </h2>
                  <div className="flex flex-wrap gap-2.5">
                    {["Train", "Hire", "Pay globally"].map((label) => (
                      <span
                        key={label}
                        className="text-white text-sm font-bold border border-white/40 rounded-full px-4 py-2"
                      >
                        {label}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BusinessHeaderSection;
